module.exports = __webpack_public_path__ + "static/media/Psychiatry.25536518.png";